import { render, staticRenderFns } from "./UiTextarea.vue?vue&type=template&id=3bb631dc&scoped=true&"
import script from "./UiTextarea.vue?vue&type=script&lang=js&"
export * from "./UiTextarea.vue?vue&type=script&lang=js&"
import style0 from "./UiTextarea.vue?vue&type=style&index=0&id=3bb631dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb631dc",
  null
  
)

export default component.exports